// extracted by mini-css-extract-plugin
export var circle = "EmployeeIcons-module--circle--305b9";
export var circleBox = "EmployeeIcons-module--circleBox--93818";
export var container = "EmployeeIcons-module--container--7cf98";
export var title = "EmployeeIcons-module--title--c30c5";